<!--材料库-->
<template>
  <d2-container>
    <div v-show="!showTabFom">
      <el-row style="margin-bottom: 20px">
        <el-col :span="4">
          <popover-form
            popoverWidth="680"
            :formConfig="advSearch"
            v-model="searchForm"
            @onSubmit="searching"
          ></popover-form>
        </el-col>
        <el-col :span="20">
          <div class="text-align_right">
            <el-button
              type="success"
              v-if="!tableUse.show &&verifyAuthority('system.gsims.bdStructureMaterialTable.import')"
              @click="dialogShow=true"
            >导入</el-button>
            <dialogUploadFile
              :importUrl="this.$url.importFiles.bdStructureMaterialTable"
              exportFile="cai_liao_ku"
              :dialogShow="dialogShow"
              @cancel="cancel"
            ></dialogUploadFile>
           <el-button
             type="primary"
             v-if="!tableUse.show &&verifyAuthority('system.gsims.bdStructureMaterialTable.export')"
             @click="fileDownload($url.downLoad.bdStructureMaterialDownLoad,{exportData,...searchForm})"
           >导出</el-button>
            <el-button
              type="primary"
              v-if="(!tableUse.show)&&verifyAuthority('system.gsims.bdStructureMaterialTable.add')"
              @click="addRow"
            >新增</el-button>
          </div>
        </el-col>
      </el-row>
      <div>
        <dynamic-table
          :tableSet="tableSet"
          :tableUse="tableUse"
          :tableData="tableData"
          :pageIndex="pageIndex"
          :pageShow="false"
          :pageShowX="true"
          @goPageIndex="goPageIndex"
          :pageCount="pageCount"
          @rowClick="rowClick($event)"
          @onButton="clickDialog($event)"
          @onSelection="selection($event)"
        ></dynamic-table>
      </div>
    </div>
    <div v-show="showTabFom">
      <div>
        <div>
          <div class="text-align_right">
            <el-button-group>
              <el-button
                type="primary"
                v-if="(operationType==1||operationType==2)"
                @click="dataSubmit"
              >保存</el-button>
              <el-button type="primary" @click="close">返回</el-button>
            </el-button-group>
          </div>
          <divider title="材料信息" />
          <dynamic-form ref="form" :formConfig="formConfig" :disabled="disabled" v-model="form"></dynamic-form>
          <divider title="图片" />
          <el-card class="box-card card_margintop">
            <div class="text-align_right">
              <dialogImg
                :dialogShow="dialogShows"
                :actionType="'backend/basic/material/images/'"
                @successData="successData"
              ></dialogImg>
              <el-button
                type="success"
                size="small"
                v-if="(operationType==1||operationType==2)"
                @click="dialogShows=true"
              >上传</el-button>
            </div>
            <imgVideo v-if="true"
              :data="form.imagePath"
              :delShow="operationType"
              @delImg="delImg"
              :isImg="true"
              :isVideo="false"
            ></imgVideo>
          </el-card>
        </div>
      </div>
    </div>
    <template slot="footer" v-if="showTabFom">
      <billing-info :billingInfo="form"></billing-info>
    </template>
  </d2-container>
</template>
<script>
export default {
  name: "bdStructureMaterialTable",
  //import引入的组件需要注入到对象中才能使用
  props: {
    tableUse: {
      type: Object,
      default: () => {
        return {
          show: false,
          size: "small",
          type: "primary",
          plain: true,
          round: false,
          circle: false,
          loading: false,
          disabled: false,
          title: "使用",
          name: "使用",
          horizon: ""
        };
      }
    }
  },
  data() {
    return {
      dialogShow: false,
      dialogShows: false,
      exportData: {},
      showTabFom: false, //表格表单转换状态
      operationType: 1, //主表操作状态
      disabled: false,
      childDisabled: false,
      dialogTableVisible: false, //路段选择

      /********* 查询---*/
      searchForm: {
        materialName: "",
        materialCode: "",
        materialType: "",
        isValid: "",
        horizon: ""
      },
      advSearch: {
        list: [
          {
            type: "input",
            icon: "icon-input",
            options: {
              width: "200px",
              defaultValue: "",
              required: false,
              dataType: "string",
              pattern: "",
              placeholder: "请输入",
              customClass: "",
              disabled: false,
              labelWidth: 100,
              isLabelWidth: false,
              hidden: false,
              dataBind: true,
              showPassword: false,
              remoteFunc: "func_1573613031116"
            },
            name: "材料编码",
            novalid: {},
            key: "1573617164551",
            model: "materialCode",
            rules: [
              {
                type: "string",
                message: "材料编码格式不正确"
              }
            ]
          },
          {
            type: "input",
            icon: "icon-input",
            options: {
              width: "200px",
              defaultValue: "",
              required: false,
              dataType: "string",
              pattern: "",
              placeholder: "请输入",
              customClass: "",
              disabled: false,
              labelWidth: 100,
              isLabelWidth: false,
              hidden: false,
              dataBind: true,
              showPassword: false,
              remoteFunc: "func_1573613103610"
            },
            name: "材料名称",
            novalid: {},
            key: "1573617169661",
            model: "materialName",
            rules: [
              {
                type: "string",
                message: "材料名称格式不正确"
              }
            ]
          },
          {
            type: "select",
            icon: "icon-select",
            options: {
              defaultValue: "",
              multiple: false,
              disabled: false,
              clearable: false,
              placeholder: "请选择",
              required: false,
              showLabel: false,
              width: "200px",
              options: [
                {
                  value: "Option 3"
                }
              ],
              remote: true,
              filterable: false,
              remoteOptions: [],
              props: {
                value: "name",
                label: "name"
              },
              remoteFunc: this.getDiction,
              customClass: "",
              labelWidth: 100,
              isLabelWidth: false,
              hidden: false,
              dataBind: true
            },
            name: "路面材料类别",
            novalid: {},
            key: "1573617218350",
            model: "materialType",
            rules: []
          },
          {
            type: "select",
            icon: "icon-select",
            options: {
              defaultValue: "",
              multiple: false,
              disabled: false,
              clearable: false,
              placeholder: "请选择",
              required: false,
              showLabel: false,
              width: "250px",
              options: [
                {
                  value: "Option 1"
                }
              ],
              remote: true,
              filterable: false,
              remoteOptions: [],
              props: {
                value: "name",
                label: "name"
              },
              remoteFunc: this.getDictionS,
              customClass: "",
              labelWidth: 100,
              isLabelWidth: false,
              hidden: false,
              dataBind: true
            },
            name: "材料可用层位",
            novalid: {},
            key: "1573613500564",
            model: "horizon",
            rules: [
              {
                required: false,
                message: "材料可用层位必须填写"
              }
            ]
          }
        ],
        config: {
          labelWidth: 100,
          labelPosition: "right",
          size: "medium",
          customClass: ""
        }
      },
      /********* 查询---*/
      /**********主表表格 */
      tableSet: {
        tableColumn: [
          {
            prop: "materialCode",
            label: "材料编码"
          },
          {
            prop: "materialName",
            label: "材料名称"
          },
          {
            prop: "price",
            label: "单价(元/cm·㎡)"
          },
          {
            prop: "materialType",
            label: "材料类别"
          },
          {
            prop: "horizon",
            label: "材料可用层位"
          },
          {
            prop: "isSystem",
            label: "材料库来源",
            type: "tag",
            options: [
              {
                value: "1",
                color: "info",
                label: "默认库"
              },
              {
                value: "0",
                color: "success",
                label: "用户自定义"
              }
            ]
          }
        ],
        tableColBtn: [
          {
            show: true,
            size: "small ",
            type: "primary",
            plain: true,
            round: false,
            circle: false,
            loading: false,
            disabled: false,
            icon: "el-icon-view",
            title: "查看",
            name: "查看",
            click: this.rowClick
          },
          {
            show: this.verifyAuthority(
              "system.gsims.bdStructureMaterialTable.edit"
            ),
            size: "small ",
            type: "primary",
            plain: true,
            round: false,
            circle: false,
            loading: false,
            disabled: false,
            icon: "el-icon-edit",
            title: "编辑",
            name: "编辑",
            click: this.edit
          },
          {
            show: this.verifyAuthority(
              "system.gsims.bdStructureMaterialTable.del"
            ),
            size: "small ",
            type: "danger",
            plain: true,
            round: false,
            circle: false,
            loading: false,
            disabled: false,
            icon: "el-icon-delete",
            title: "删除",
            name: "删除",
            click: this.del
          }
        ]
      },
      tableData: [],
      pageIndex: 1,
      pageSize: 10,
      pageCount: 0,
      /************主表表单 */
      form: {
        structureMaterialId: 0, /// 主键
        materialCode: "", /// 材料编码
        materialName: "", /// 材料名称
        price: "", /// 单价
        materialType: "", /// 路面材料类别
        horizon: "", //材料可用层位
        materialModuleTypeCode: "", /// MD：养护材料；BD：路面结构材料
        materialDensityNum: 0, /// 材料密度
        remark: "", /// 备注
        imagePath: "", /// 图片路径
        createTime: "", /// 创建时间
        updateTime: "", /// 修改时间
        createUser: "", /// 创建人
        createUserName: "", /// 创建人
        updateUser: "", /// 修改人
        updateUserName: "", /// 修改人
        isSystem: "0", /// 是否系统
        delUser: "", /// 删除人
        delTime: "", /// 删除时间
        isValid: "", /// 是否启用
        isDelete: "", /// 是否删除
        r1: "", /// R1
        r2: "", /// R2
        r3: "", /// R3
        r4: "", /// R4
        r5: "" /// R5
      },
      formConfig: {
        list: [
          {
            type: "input",
            icon: "icon-input",
            options: {
              width: "250px",
              defaultValue: "",
              required: true,
              dataType: "string",
              pattern: "",
              placeholder: "请输入",
              customClass: "",
              disabled: false,
              labelWidth: 100,
              isLabelWidth: false,
              hidden: false,
              dataBind: true,
              showPassword: false,
              remoteFunc: "func_1573613031116"
            },
            name: "材料编码",
            novalid: {},
            key: "1573613031116",
            model: "materialCode",
            rules: [
              {
                type: "string",
                message: "材料编码格式不正确"
              },
              {
                required: true,
                message: "材料编码必须填写"
              }
            ]
          },
          {
            type: "input",
            icon: "icon-input",
            options: {
              width: "250px",
              defaultValue: "",
              required: true,
              dataType: "string",
              pattern: "",
              placeholder: "请输入",
              customClass: "",
              disabled: false,
              labelWidth: 100,
              isLabelWidth: false,
              hidden: false,
              dataBind: true,
              showPassword: false,
              remoteFunc: "func_1573613103610"
            },
            name: "材料名称",
            novalid: {},
            key: "1573613103610",
            model: "materialName",
            rules: [
              {
                type: "string",
                message: "材料名称格式不正确"
              },
              {
                required: true,
                message: "材料名称必须填写"
              }
            ]
          },
          {
            type: "number",
            icon: "icon-number",
            options: {
              width: "250px",
              required: true,
              defaultValue: 0,
              min: 0,
              max: 9999999,
              step: 0.01,
              precision: 2,
              disabled: false,
              controlsPosition: "",
              customClass: "",
              labelWidth: 100,
              isLabelWidth: false,
              hidden: false,
              dataBind: true,
              remoteFunc: "func_1573613212504"
            },
            name: "单价(元/cm·㎡)",
            novalid: {},
            key: "1573613212504",
            model: "price",
            rules: [
              {
                required: true,
                message: "单价必须填写"
              }
            ]
          },
          {
            type: "select",
            icon: "icon-select",
            options: {
              defaultValue: "",
              multiple: false,
              disabled: false,
              clearable: false,
              placeholder: "请选择",
              required: true,
              showLabel: false,
              width: "250px",
              options: [
                {
                  value: "Option 3"
                }
              ],
              remote: true,
              filterable: false,
              remoteOptions: [],
              props: {
                value: "name",
                label: "name"
              },
              remoteFunc: this.getDiction,
              customClass: "",
              labelWidth: 100,
              isLabelWidth: false,
              hidden: false,
              dataBind: true
            },
            name: "路面材料类别",
            novalid: {},
            key: "1573613498337",
            model: "materialType",
            rules: [
              {
                required: true,
                message: "路面材料类别必须填写"
              }
            ]
          },
          {
            type: "select",
            icon: "icon-select",
            options: {
              defaultValue: "",
              multiple: true,
              disabled: false,
              clearable: false,
              placeholder: "请选择",
              required: true,
              showLabel: false,
              width: "250px",
              options: [
                {
                  value: "Option 1"
                }
              ],
              remote: true,
              filterable: false,
              remoteOptions: [],
              props: {
                value: "name",
                label: "name"
              },
              remoteFunc: this.getDictionS,
              customClass: "",
              labelWidth: 100,
              isLabelWidth: false,
              hidden: false,
              dataBind: true
            },
            name: "材料可用层位",
            novalid: {},
            key: "1573613500564",
            model: "horizon",
            rules: [
              {
                required: true,
                message: "材料可用层位必须填写"
              }
            ]
          },
          {
            type: "select",
            icon: "icon-select",
            options: {
              defaultValue: "",
              multiple: false,
              disabled: true,
              clearable: false,
              placeholder: "",
              required: false,
              showLabel: false,
              width: "250px",
              options: [
                { value: "0", name: "用户自定义" },
                { value: "1", name: "默认库" }
              ],
              remote: false,
              filterable: false,
              remoteOptions: [],
              props: {
                value: "value",
                label: "name"
              },
              remoteFunc: "this.getSystem",
              customClass: "",
              labelWidth: 100,
              isLabelWidth: false,
              hidden: false,
              dataBind: true
            },
            name: "材料库来源",
            novalid: {},
            key: "1573613986535",
            model: "isSystem",
            rules: []
          },
          {
            type: "textarea",
            icon: "icon-diy-com-textarea",
            options: {
              width: "500px",
              defaultValue: "",
              required: false,
              disabled: false,
              pattern: "",
              placeholder: "",
              customClass: "",
              labelWidth: 100,
              isLabelWidth: false,
              hidden: false,
              dataBind: true,
              remoteFunc: "func_1573614345875"
            },
            name: "备注",
            novalid: {},
            key: "1573614345875",
            model: "remark",
            rules: []
          }
        ],
        config: {
          labelWidth: 180,
          labelPosition: "right",
          size: "medium",
          customClass: ""
        }
      }
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    selection(val) {
      let data = new Array();
      if (val) {
        for (let item of val) {
          data.push(item.structureMaterialId);
        }
      }
      this.exportData = { ...this.searchForm, rowCodes: data.toString() };
    },
    cancel() {
      this.dialogShow = false;
    },
    successData(datas) {
      if (datas == "") {
        this.dialogShows = false;
      } else {
        let vals = JSON.parse(datas);
        if (this.form.imagePath == "" || this.form.imagePath == null) {
          this.form.imagePath = datas;
        } else {
          let disVal = JSON.parse(this.form.imagePath);
          disVal.img += vals.img;
          disVal.video += vals.video;
          this.form.imagePath = JSON.stringify(disVal);
        }
        this.dialogShows = false;
      }
    },
    delImg(val) {
      this.form.imagePath = val;
    },
    /********字典获取 ******/
    getDiction(target, targets) {
      let name = target.form.name;
      this.$http
        .post(this.$url.getDict, {
          search: name
        })
        .then(res => {
          let { data } = res;
          target.setList(data);
        });
    },
    getDictionS(target, targets) {
      let name = "防护_层位";
      this.$http
        .post(this.$url.getDict, {
          search: name
        })
        .then(res => {
          let { data } = res;
          target.setList(data);
        });
    },
    getSystem(target, targets) {
      let data = [
        { value: "0", name: "用户自定义" },
        { value: "1", name: "默认库" }
      ];
      target.setList(data);
    },
    //主表操作//
    initForm() {
      this.form = { ...this.saveForm };
    },
    addRow() {
      //新增
      this.showTabFom = true;
      this.operationType = 1;
      this.disabled = false;
      this.resetForm("form");
    },
    searching(){
      this.pageIndex = 1;
      this.searchTable();
    },
    searchTable() {
      //获取表格数据
      // this.pageIndex = 1;
      this.tableUse.show && (this.searchForm.horizons = this.tableUse.horizons);
      this.$http
        .postHandle("", this.$url.bdStructureMaterial.getmaterials, {
          ...this.searchForm,
          pageIndex: this.pageIndex,
          pageSize: this.pageSize
        })
        .then(res => {
          this.tableData = res.data;
          this.pageCount = res.pageCount;
        });
    },
    goPageIndex(pageIndex, pageSize) {
      //分页
      this.pageIndex = pageIndex;
      this.pageSize = pageSize;
      this.$http
        .postHandle("", this.$url.bdStructureMaterial.getmaterials, {
          ...this.searchForm,
          pageIndex: this.pageIndex,
          pageSize: pageSize
        })
        .then(res => {
          this.tableData = res.data;
          this.pageCount = res.pageCount;
        });
    },
    rowClick(val) {
      //查看
      this.$http
        .post(this.$url.bdStructureMaterial.getmaterials, {
          tructureMaterialId: val.structureMaterialId
        })
        .then(res => {
          this.form = this.$formSetForm(this.form, res.data[0]);
          let horizons = this.form.horizon;
          typeof horizons == "string" &&
            horizons.indexOf(",") >= 0 &&
            (this.form.horizon = horizons.split(","));
          this.operationType = 3;
          this.disabled = true;
          this.showTabFom = true;
        });
    },
    edit(row, index) {
      //编辑
      this.$http
        .post(this.$url.bdStructureMaterial.getmaterials, {
          tructureMaterialId: row.structureMaterialId
        })
        .then(res => {
          this.form = this.$formSetForm(this.form, res.data[0]);
          let horizons = this.form.horizon;
          if (typeof horizons == "string") {
            this.form.horizon = horizons.split(",");
          }
          this.operationType = 2;
          this.disabled = false;
          this.showTabFom = true;
        });
    },
    del(row, index) {
      //删除
      this.$msgDel(this.$url.bdStructureMaterial.operationmaterial, {
        material: row,
        operationType: 8
      }).then(res => {
        if((this.tableData.length<=1)&&(this.pageIndex>1)){
          this.pageIndex=this.pageIndex-1;
        }
        this.searchTable();
      });
    },
    //操作
    dataSubmit() {
      this.$refs.form.submit().then(res => {
        let forms = this.$formSetForm(this.form, this.form);
        forms.horizon = forms.horizon.toString();
        this.$http
          .postHandle("保存", this.$url.bdStructureMaterial.operationmaterial, {
            material: forms,
            operationType: this.operationType
          })
          .then(res => {
            this.showTabFom = false;
            this.searchTable();
          });
      });
    },
    close() {
      //返回
      this.$closePage(this.operationType).then(() => {
        this.showTabFom = false;
        this.searchTable();
      });
    },
    //重置
    resetForm(formName) {
      let that = this;
      this.$nextTick(() => {
        that.$refs[formName].resetForm();
        that.form.isSystem = "0";
      });
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.searchTable();
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {}
};
</script>
<vue-filename-injector>
export default function (Component) {
  Component.options.__source = "src/views/basic/roadProduction/bdStructureMaterialTable.vue"
}
</vue-filename-injector>
